// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2uBau","buttons":"RemoveExpirationActionButtons_buttons__23_uT"};